import { QuizQuestion } from '@/types';

// 问答题库
// // capital 首都省会，abbreviation 简称，neighbors 相邻省份，landmarks 著名景点
export const QUIZ_QUESTIONS: QuizQuestion[] = [
  // 北京相关题目
  {
    id: 'beijing_abbreviation',
    provinceId: 'beijing',
    type: 'abbreviation',
    question: '北京市的简称是什么？',
    options: ['京', '津', '沪', '渝'],
    correctAnswer: 0,
    explanation: '北京市的简称是"京"，来源于古代的蓟城。'
  },
  {
    id: 'beijing_landmarks',
    provinceId: 'beijing',
    type: 'landmarks',
    question: '以下哪个不是北京的著名景点？',
    options: ['天安门', '故宫', '外滩', '颐和园'],
    correctAnswer: 2,
    explanation: '外滩是上海的著名景点，不在北京。'
  },
  {
    id: 'beijing_neighbors',
    provinceId: 'beijing',
    type: 'neighbors',
    question: '北京市与哪些省份相邻？',
    options: ['河北、天津', '河北、山西', '天津、山东', '河南、山西'],
    correctAnswer: 0,
    explanation: '北京市被河北省环绕，并与天津市相邻。'
  },

  // 上海相关题目
  {
    id: 'shanghai_abbreviation',
    provinceId: 'shanghai',
    type: 'abbreviation',
    question: '上海市的简称是？',
    options: ['沪', '申', '海', '津'],
    correctAnswer: 0,
    explanation: '上海市的简称是"沪"，来源于古代的渔具"扈"。'
  },
  {
    id: 'shanghai_landmarks',
    provinceId: 'shanghai',
    type: 'landmarks',
    question: '上海的标志性建筑是？',
    options: ['天安门', '东方明珠', '广州塔', '央视大楼'],
    correctAnswer: 1,
    explanation: '东方明珠电视塔是上海的标志性建筑之一。'
  },
  {
    id: 'shanghai_neighbors',
    provinceId: 'shanghai',
    type: 'neighbors',
    question: '上海市与哪个省份相邻？',
    options: ['江苏省', '浙江省', '江苏省和浙江省', '安徽省'],
    correctAnswer: 2,
    explanation: '上海市位于长江入海口，与江苏省和浙江省接壤。'
  },

  // 天津相关题目
  {
    id: 'tianjin_abbreviation',
    provinceId: 'tianjin',
    type: 'abbreviation',
    question: '天津市的简称是？',
    options: ['津', '京', '冀', '塘'],
    correctAnswer: 0,
    explanation: '天津市的简称是"津"，意为渡口，因地处渤海湾重要渡口而得名。'
  },
  {
    id: 'tianjin_landmarks',
    provinceId: 'tianjin',
    type: 'landmarks',
    question: '天津著名的古建筑是？',
    options: ['天津之眼', '五大道', '独乐寺', '古文化街'],
    correctAnswer: 2,
    explanation: '独乐寺是天津现存最古老的木结构建筑，始建于唐代。'
  },

  // 重庆相关题目
  {
    id: 'chongqing_abbreviation',
    provinceId: 'chongqing',
    type: 'abbreviation',
    question: '重庆市的简称是？',
    options: ['渝', '巴', '蜀', '重'],
    correctAnswer: 0,
    explanation: '重庆市的简称是"渝"，因古代属渝州而得名。'
  },
  {
    id: 'chongqing_capital',
    provinceId: 'chongqing',
    type: 'capital',
    question: '重庆市的行政中心是？',
    options: ['渝中区', '江北区', '沙坪坝区', '九龙坡区'],
    correctAnswer: 0,
    explanation: '渝中区是重庆市的行政中心和商业中心。'
  },
  {
    id: 'chongqing_landmarks',
    provinceId: 'chongqing',
    type: 'landmarks',
    question: '重庆最著名的自然景观是？',
    options: ['长江三峡', '黄果树瀑布', '张家界', '九寨沟'],
    correctAnswer: 0,
    explanation: '长江三峡的瞿塘峡、巫峡部分位于重庆市境内。'
  },

  // 河北相关题目
  {
    id: 'hebei_capital',
    provinceId: 'hebei',
    type: 'capital',
    question: '河北省的省会是？',
    options: ['石家庄', '唐山', '保定', '邯郸'],
    correctAnswer: 0,
    explanation: '河北省的省会是石家庄市。'
  },
  {
    id: 'hebei_abbreviation',
    provinceId: 'hebei',
    type: 'abbreviation',
    question: '河北省的简称是？',
    options: ['冀', '晋', '豫', '鲁'],
    correctAnswer: 0,
    explanation: '河北省的简称是"冀"，来源于古代的冀州。'
  },

  // 山西相关题目
  {
    id: 'shanxi_capital',
    provinceId: 'shanxi',
    type: 'capital',
    question: '山西省的省会是？',
    options: ['太原', '大同', '临汾', '运城'],
    correctAnswer: 0,
    explanation: '山西省的省会是太原市。'
  },
  {
    id: 'shanxi_landmarks',
    provinceId: 'shanxi',
    type: 'landmarks',
    question: '山西省著名的佛教圣地是？',
    options: ['五台山', '峨眉山', '普陀山', '九华山'],
    correctAnswer: 0,
    explanation: '五台山是中国四大佛教名山之一，位于山西省。'
  },

  // 内蒙古相关题目
  {
    id: 'neimenggu_capital',
    provinceId: 'neimenggu',
    type: 'capital',
    question: '内蒙古自治区的首府是？',
    options: ['呼和浩特', '包头', '鄂尔多斯', '赤峰'],
    correctAnswer: 0,
    explanation: '内蒙古自治区的首府是呼和浩特市。'
  },
  {
    id: 'neimenggu_landmarks',
    provinceId: 'neimenggu',
    type: 'landmarks',
    question: '内蒙古著名的草原是？',
    options: ['呼伦贝尔草原', '若尔盖草原', '那拉提草原', '巴音布鲁克草原'],
    correctAnswer: 0,
    explanation: '呼伦贝尔草原是世界著名的天然牧场，位于内蒙古。'
  },

  // 辽宁相关题目
  {
    id: 'liaoning_capital',
    provinceId: 'liaoning',
    type: 'capital',
    question: '辽宁省的省会是？',
    options: ['沈阳', '大连', '鞍山', '抚顺'],
    correctAnswer: 0,
    explanation: '辽宁省的省会是沈阳市，同时也是东北地区的重要工业城市。'
  },
  {
    id: 'liaoning_abbreviation',
    provinceId: 'liaoning',
    type: 'abbreviation',
    question: '辽宁省的简称是？',
    options: ['辽', '宁', '沈', '营'],
    correctAnswer: 0,
    explanation: '辽宁省的简称是"辽"，因境内有辽河而得名。'
  },

  // 吉林相关题目
  {
    id: 'jilin_capital',
    provinceId: 'jilin',
    type: 'capital',
    question: '吉林省的省会是？',
    options: ['长春', '吉林', '四平', '通化'],
    correctAnswer: 0,
    explanation: '吉林省的省会是长春市，是中国汽车工业的重要基地。'
  },
  {
    id: 'jilin_landmarks',
    provinceId: 'jilin',
    type: 'landmarks',
    question: '吉林省著名的自然景观是？',
    options: ['长白山', '黄山', '泰山', '华山'],
    correctAnswer: 0,
    explanation: '长白山是中国东北著名的山脉，拥有丰富的自然资源。'
  },

  // 黑龙江相关题目
  {
    id: 'heilongjiang_capital',
    provinceId: 'heilongjiang',
    type: 'capital',
    question: '黑龙江省的省会是？',
    options: ['哈尔滨', '齐齐哈尔', '牡丹江', '大庆'],
    correctAnswer: 0,
    explanation: '黑龙江省的省会是哈尔滨市，有"冰城"之称。'
  },
  {
    id: 'heilongjiang_landmarks',
    provinceId: 'heilongjiang',
    type: 'landmarks',
    question: '黑龙江省著名的河流是？',
    options: ['黑龙江', '松花江', '辽河', '鸭绿江'],
    correctAnswer: 0,
    explanation: '黑龙江是中俄界河，也是中国东北地区的重要河流。'
  },

  // 江苏相关题目
  {
    id: 'jiangsu_capital',
    provinceId: 'jiangsu',
    type: 'capital',
    question: '江苏省的省会是？',
    options: ['南京', '苏州', '无锡', '常州'],
    correctAnswer: 0,
    explanation: '江苏省的省会是南京市，是中国四大古都之一。'
  },
  {
    id: 'jiangsu_abbreviation',
    provinceId: 'jiangsu',
    type: 'abbreviation',
    question: '江苏省的简称是？',
    options: ['苏', '江', '宁', '吴'],
    correctAnswer: 0,
    explanation: '江苏省的简称是"苏"，因古代属苏州府而得名。'
  },

  // 浙江相关题目
  {
    id: 'zhejiang_capital',
    provinceId: 'zhejiang',
    type: 'capital',
    question: '浙江省的省会是？',
    options: ['杭州', '宁波', '温州', '绍兴'],
    correctAnswer: 0,
    explanation: '浙江省的省会是杭州市，以西湖闻名于世。'
  },
  {
    id: 'zhejiang_landmarks',
    provinceId: 'zhejiang',
    type: 'landmarks',
    question: '浙江省著名的景点是？',
    options: ['西湖', '黄山', '泰山', '九寨沟'],
    correctAnswer: 0,
    explanation: '西湖位于杭州市，是中国著名的风景名胜区。'
  },

  // 安徽相关题目
  {
    id: 'anhui_capital',
    provinceId: 'anhui',
    type: 'capital',
    question: '安徽省的省会是？',
    options: ['合肥', '芜湖', '安庆', '蚌埠'],
    correctAnswer: 0,
    explanation: '安徽省的省会是合肥市，是华东地区的重要城市。'
  },
  {
    id: 'anhui_abbreviation',
    provinceId: 'anhui',
    type: 'abbreviation',
    question: '安徽省的简称是？',
    options: ['皖', '徽', '安', '合'],
    correctAnswer: 0,
    explanation: '安徽省的简称是"皖"，因境内有皖山（天柱山）而得名。'
  },

  // 福建相关题目
  {
    id: 'fujian_capital',
    provinceId: 'fujian',
    type: 'capital',
    question: '福建省的省会是？',
    options: ['福州', '厦门', '泉州', '漳州'],
    correctAnswer: 0,
    explanation: '福建省的省会是福州市，又称"榕城"。'
  },
  {
    id: 'fujian_landmarks',
    provinceId: 'fujian',
    type: 'landmarks',
    question: '福建省著名的土楼群位于哪个地区？',
    options: ['龙岩', '厦门', '福州', '泉州'],
    correctAnswer: 0,
    explanation: '福建土楼主要分布在龙岩市永定区和漳州市南靖县等地。'
  },

  // 江西相关题目
  {
    id: 'jiangxi_capital',
    provinceId: 'jiangxi',
    type: 'capital',
    question: '江西省的省会是？',
    options: ['南昌', '赣州', '九江', '景德镇'],
    correctAnswer: 0,
    explanation: '江西省的省会是南昌市，是中国人民解放军的诞生地。'
  },
  {
    id: 'jiangxi_abbreviation',
    provinceId: 'jiangxi',
    type: 'abbreviation',
    question: '江西省的简称是？',
    options: ['赣', '江', '昌', '洪'],
    correctAnswer: 0,
    explanation: '江西省的简称是"赣"，因赣江贯穿全省而得名。'
  },

  // 山东相关题目
  {
    id: 'shandong_capital',
    provinceId: 'shandong',
    type: 'capital',
    question: '山东省的省会是？',
    options: ['济南', '青岛', '烟台', '潍坊'],
    correctAnswer: 0,
    explanation: '山东省的省会是济南市，以泉水众多而被誉为"泉城"。'
  },
  {
    id: 'shandong_landmarks',
    provinceId: 'shandong',
    type: 'landmarks',
    question: '山东省著名的名山是？',
    options: ['泰山', '黄山', '华山', '庐山'],
    correctAnswer: 0,
    explanation: '泰山位于山东省泰安市，是中国五岳之首。'
  },

  // 河南相关题目
  {
    id: 'henan_capital',
    provinceId: 'henan',
    type: 'capital',
    question: '河南省的省会是？',
    options: ['郑州', '洛阳', '开封', '安阳'],
    correctAnswer: 0,
    explanation: '河南省的省会是郑州市，是中国中部地区的重要交通枢纽。'
  },
  {
    id: 'henan_abbreviation',
    provinceId: 'henan',
    type: 'abbreviation',
    question: '河南省的简称是？',
    options: ['豫', '河', '郑', '洛'],
    correctAnswer: 0,
    explanation: '河南省的简称是"豫"，因古代属豫州而得名，有"中原"、"中州"之称。'
  },

  // 湖北相关题目
  {
    id: 'hubei_capital',
    provinceId: 'hubei',
    type: 'capital',
    question: '湖北省的省会是？',
    options: ['武汉', '宜昌', '襄阳', '荆州'],
    correctAnswer: 0,
    explanation: '湖北省的省会是武汉市，由武昌、汉口、汉阳三镇组成。'
  },
  {
    id: 'hubei_landmarks',
    provinceId: 'hubei',
    type: 'landmarks',
    question: '湖北省著名的湖泊是？',
    options: ['东湖', '太湖', '洞庭湖', '鄱阳湖'],
    correctAnswer: 0,
    explanation: '东湖位于武汉市，是中国最大的城中湖之一。'
  },

  // 湖南相关题目
  {
    id: 'hunan_capital',
    provinceId: 'hunan',
    type: 'capital',
    question: '湖南省的省会是？',
    options: ['长沙', '株洲', '湘潭', '衡阳'],
    correctAnswer: 0,
    explanation: '湖南省的省会是长沙市，是长江中游地区重要的中心城市。'
  },
  {
    id: 'hunan_abbreviation',
    provinceId: 'hunan',
    type: 'abbreviation',
    question: '湖南省的简称是？',
    options: ['湘', '湖', '楚', '长'],
    correctAnswer: 0,
    explanation: '湖南省的简称是"湘"，因湘江贯穿全省而得名。'
  },

  // 广东相关题目
  {
    id: 'guangdong_capital',
    provinceId: 'guangdong',
    type: 'capital',
    question: '广东省的省会是？',
    options: ['广州', '深圳', '珠海', '东莞'],
    correctAnswer: 0,
    explanation: '广东省的省会是广州市，别称"羊城"、"花城"。'
  },
  {
    id: 'guangdong_landmarks',
    provinceId: 'guangdong',
    type: 'landmarks',
    question: '广东省著名的建筑是？',
    options: ['广州塔', '东方明珠', '上海中心', '央视大楼'],
    correctAnswer: 0,
    explanation: '广州塔又称"小蛮腰"，是广州市的标志性建筑。'
  },

  // 海南相关题目
  {
    id: 'hainan_capital',
    provinceId: 'hainan',
    type: 'capital',
    question: '海南省的省会是？',
    options: ['海口', '三亚', '琼海', '文昌'],
    correctAnswer: 0,
    explanation: '海南省的省会是海口市，是海南岛北部的经济、文化中心。'
  },
  {
    id: 'hainan_landmarks',
    provinceId: 'hainan',
    type: 'landmarks',
    question: '海南省著名的旅游景点是？',
    options: ['亚龙湾', '鼓浪屿', '张家界', '黄山'],
    correctAnswer: 0,
    explanation: '亚龙湾位于三亚市，是海南著名的海滨旅游度假区。'
  },

  // 四川相关题目
  {
    id: 'sichuan_capital',
    provinceId: 'sichuan',
    type: 'capital',
    question: '四川省的省会是？',
    options: ['成都', '绵阳', '德阳', '宜宾'],
    correctAnswer: 0,
    explanation: '四川省的省会是成都市，是西南地区的重要中心城市。'
  },
  {
    id: 'sichuan_landmarks',
    provinceId: 'sichuan',
    type: 'landmarks',
    question: '四川省著名的自然景观是？',
    options: ['九寨沟', '黄山', '张家界', '西湖'],
    correctAnswer: 0,
    explanation: '九寨沟位于四川省阿坝藏族羌族自治州，是世界自然遗产。'
  },

  // 贵州相关题目
  {
    id: 'guizhou_capital',
    provinceId: 'guizhou',
    type: 'capital',
    question: '贵州省的省会是？',
    options: ['贵阳', '遵义', '安顺', '六盘水'],
    correctAnswer: 0,
    explanation: '贵州省的省会是贵阳市，有"林城"之称。'
  },
  {
    id: 'guizhou_landmarks',
    provinceId: 'guizhou',
    type: 'landmarks',
    question: '贵州省著名的瀑布是？',
    options: ['黄果树瀑布', '壶口瀑布', '庐山瀑布', '诺日朗瀑布'],
    correctAnswer: 0,
    explanation: '黄果树瀑布是中国最大的瀑布，位于贵州省安顺市。'
  },

  // 云南相关题目
  {
    id: 'yunnan_capital',
    provinceId: 'yunnan',
    type: 'capital',
    question: '云南省的省会是？',
    options: ['昆明', '大理', '丽江', '香格里拉'],
    correctAnswer: 0,
    explanation: '云南省的省会是昆明市，有"春城"之称，因气候四季如春而得名。'
  },
  {
    id: 'yunnan_landmarks',
    provinceId: 'yunnan',
    type: 'landmarks',
    question: '云南省著名的世界文化遗产是？',
    options: ['丽江古城', '平遥古城', '乌镇', '周庄'],
    correctAnswer: 0,
    explanation: '丽江古城位于云南省丽江市，是中国历史文化名城，被列入世界文化遗产。'
  },

  // 陕西相关题目
  {
    id: 'shaanxi_capital',
    provinceId: 'shaanxi',
    type: 'capital',
    question: '陕西省的省会是？',
    options: ['西安', '宝鸡', '咸阳', '延安'],
    correctAnswer: 0,
    explanation: '陕西省的省会是西安市，是中国四大古都之一，历史上有多个王朝在此建都。'
  },
  {
    id: 'shaanxi_landmarks',
    provinceId: 'shaanxi',
    type: 'landmarks',
    question: '陕西省著名的世界文化遗产是？',
    options: ['兵马俑', '长城', '故宫', '莫高窟'],
    correctAnswer: 0,
    explanation: '秦始皇兵马俑位于西安市临潼区，是世界第八大奇迹之一。'
  },

  // 甘肃相关题目
  {
    id: 'gansu_capital',
    provinceId: 'gansu',
    type: 'capital',
    question: '甘肃省的省会是？',
    options: ['兰州', '天水', '酒泉', '张掖'],
    correctAnswer: 0,
    explanation: '甘肃省的省会是兰州市，位于黄河上游，是西北地区的重要交通枢纽。'
  },
  {
    id: 'gansu_landmarks',
    provinceId: 'gansu',
    type: 'landmarks',
    question: '甘肃省著名的石窟是？',
    options: ['莫高窟', '云冈石窟', '龙门石窟', '麦积山石窟'],
    correctAnswer: 0,
    explanation: '莫高窟位于敦煌市，是世界上现存规模最大、内容最丰富的佛教艺术圣地。'
  },

  // 青海相关题目
  {
    id: 'qinghai_capital',
    provinceId: 'qinghai',
    type: 'capital',
    question: '青海省的省会是？',
    options: ['西宁', '格尔木', '德令哈', '海东'],
    correctAnswer: 0,
    explanation: '青海省的省会是西宁市，是青藏高原的东方门户。'
  },
  {
    id: 'qinghai_landmarks',
    provinceId: 'qinghai',
    type: 'landmarks',
    question: '青海省著名的湖泊是？',
    options: ['青海湖', '鄱阳湖', '洞庭湖', '太湖'],
    correctAnswer: 0,
    explanation: '青海湖是中国最大的内陆湖和咸水湖，位于青海省东北部。'
  },

  // 台湾相关题目
  {
    id: 'taiwan_capital',
    provinceId: 'taiwan',
    type: 'capital',
    question: '台湾省的行政中心是？',
    options: ['台北', '高雄', '台中', '台南'],
    correctAnswer: 0,
    explanation: '台北市是台湾省的行政中心，也是台湾地区的政治、经济、文化中心。'
  },
  {
    id: 'taiwan_landmarks',
    provinceId: 'taiwan',
    type: 'landmarks',
    question: '台湾省著名的风景区是？',
    options: ['阿里山', '黄山', '张家界', '九寨沟'],
    correctAnswer: 0,
    explanation: '阿里山位于台湾省嘉义市，以森林、云海、日出和樱花闻名。'
  },

  // 广西相关题目
  {
    id: 'guangxi_capital',
    provinceId: 'guangxi',
    type: 'capital',
    question: '广西壮族自治区的首府是？',
    options: ['南宁', '桂林', '柳州', '北海'],
    correctAnswer: 0,
    explanation: '广西壮族自治区的首府是南宁市，是广西的政治、经济、文化中心。'
  },
  {
    id: 'guangxi_landmarks',
    provinceId: 'guangxi',
    type: 'landmarks',
    question: '广西著名的山水景观是？',
    options: ['桂林山水', '黄山', '张家界', '九寨沟'],
    correctAnswer: 0,
    explanation: '桂林山水以"山青、水秀、洞奇、石美"著称，是世界著名的风景名胜区。'
  },

  // 宁夏相关题目
  {
    id: 'ningxia_capital',
    provinceId: 'ningxia',
    type: 'capital',
    question: '宁夏回族自治区的首府是？',
    options: ['银川', '吴忠', '固原', '中卫'],
    correctAnswer: 0,
    explanation: '宁夏回族自治区的首府是银川市，有"塞上江南"之称。'
  },
  {
    id: 'ningxia_landmarks',
    provinceId: 'ningxia',
    type: 'landmarks',
    question: '宁夏著名的湖泊是？',
    options: ['沙湖', '青海湖', '鄱阳湖', '洞庭湖'],
    correctAnswer: 0,
    explanation: '沙湖位于银川市以北，是集沙漠、湖泊、芦苇、飞鸟、游鱼为一体的生态旅游区。'
  },

  // 新疆相关题目
  {
    id: 'xinjiang_capital',
    provinceId: 'xinjiang',
    type: 'capital',
    question: '新疆维吾尔自治区的首府是？',
    options: ['乌鲁木齐', '喀什', '伊宁', '克拉玛依'],
    correctAnswer: 0,
    explanation: '新疆维吾尔自治区的首府是乌鲁木齐市，是新疆的政治、经济、文化中心。'
  },
  {
    id: 'xinjiang_landmarks',
    provinceId: 'xinjiang',
    type: 'landmarks',
    question: '新疆著名的高山湖泊是？',
    options: ['天池', '青海湖', '纳木错', '西湖'],
    correctAnswer: 0,
    explanation: '天山天池位于乌鲁木齐市附近，是著名的高山湖泊和旅游胜地。'
  },

  // 西藏相关题目
  {
    id: 'xizang_capital',
    provinceId: 'xizang',
    type: 'capital',
    question: '西藏自治区的首府是？',
    options: ['拉萨', '日喀则', '昌都', '林芝'],
    correctAnswer: 0,
    explanation: '西藏自治区的首府是拉萨市，有"日光城"之称。'
  },
  {
    id: 'xizang_landmarks',
    provinceId: 'xizang',
    type: 'landmarks',
    question: '西藏著名的建筑是？',
    options: ['布达拉宫', '大雁塔', '少林寺', '故宫'],
    correctAnswer: 0,
    explanation: '布达拉宫位于拉萨市，是世界上海拔最高的宫殿群，被列入世界文化遗产。'
  },

  // 香港相关题目
  {
    id: 'hongkong_capital',
    provinceId: 'hongkong',
    type: 'capital',
    question: '香港特别行政区的行政中心是？',
    options: ['香港岛', '九龙', '新界', '离岛'],
    correctAnswer: 0,
    explanation: '香港特别行政区的行政中心位于香港岛，是香港的政治、经济中心。'
  },
  {
    id: 'hongkong_landmarks',
    provinceId: 'hongkong',
    type: 'landmarks',
    question: '香港著名的地标是？',
    options: ['维多利亚港', '东方明珠', '广州塔', '外滩'],
    correctAnswer: 0,
    explanation: '维多利亚港是香港的天然海港，两岸的夜景被誉为"世界三大夜景"之一。'
  },

  // 澳门相关题目
  {
    id: 'macau_capital',
    provinceId: 'macau',
    type: 'capital',
    question: '澳门特别行政区的行政中心是？',
    options: ['澳门半岛', '氹仔', '路环', '路氹城'],
    correctAnswer: 0,
    explanation: '澳门特别行政区的行政中心位于澳门半岛，是澳门的政治、经济中心。'
  },
  {
    id: 'macau_landmarks',
    provinceId: 'macau',
    type: 'landmarks',
    question: '澳门著名的建筑是？',
    options: ['大三巴牌坊', '维多利亚港', '东方明珠', '广州塔'],
    correctAnswer: 0,
    explanation: '大三巴牌坊是澳门的标志性建筑，原为圣保禄大教堂的前壁。'
  }
];


// 根据省份ID获取相关题目
export const getQuestionsByProvinceId = (provinceId: string): QuizQuestion[] => {
  return QUIZ_QUESTIONS.filter(q => q.provinceId === provinceId);
};

// 随机获取一个题目
export const getRandomQuestion = (provinceId: string): QuizQuestion | null => {
  const questions = getQuestionsByProvinceId(provinceId);
  if (questions.length === 0) return null;
  
  const randomIndex = Math.floor(Math.random() * questions.length);
  return questions[randomIndex];
};

// 获取所有题目类型
export const getQuestionTypes = () => {
  return ['capital', 'abbreviation', 'neighbors', 'landmarks'] as const;
};
